import { StepProps } from "../props";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";
import { useRunOnMountEffect } from "@portal/app/_components/hooks/useRunOnMountEffect";
import { useAuthenticatedContext } from "../../context/AuthenticatedContext";
import { useApolloClient } from "@apollo/client/react";
import { LoadingIndicator } from "@portal/app/_components/ui-elements/LoadingIndicator";
import { useQueryParams } from "@portal/app/_components/hooks/useQueryParams";
import { SIGN_IN_METHOD } from "@portal/app/_components/flow/steps/SignInStep";
import { LOGIN_QUERY_PARAMS } from "@portal/app/_common/lib/token";
import { usePageContext } from "@portal/app/_components/context/PageContext";

export const SignedInStep = ({
  mixpanelEvent,
  onLoginSuccess,
}: StepProps & {
  onLoginSuccess?: () => void;
}) => {
  const analytics = useMixpanel();
  const { isMobile } = usePageContext();
  const apolloClient = useApolloClient();
  const { getQueryParam, removeQueryParams } = useQueryParams();
  const {
    role: { activeRole },
  } = useAuthenticatedContext();

  useRunOnMountEffect(() => {
    const method = getQueryParam(LOGIN_QUERY_PARAMS.METHOD);
    void analytics.trackOnePageView(mixpanelEvent);
    setTimeout(() => {
      void analytics.track("Sign In", {
        method:
          method === SIGN_IN_METHOD.EMAIL
            ? "EMAIL"
            : SIGN_IN_METHOD.TEXT
              ? "TEXT"
              : SIGN_IN_METHOD.GOOGLE
                ? "GOOGLE"
                : undefined,
        role: activeRole,
      });
      void apolloClient!.cache.reset({ discardWatches: false });
      removeQueryParams(Object.values(LOGIN_QUERY_PARAMS));
      onLoginSuccess?.();
    }, 1000);
  });

  return <LoadingIndicator fullScreen={isMobile} />;
};
